export class User {
  username?: string | null;
  vendorId?: number | null;
  qrCode?: string | null;
  pin?: string | null;
  
  constructor(dto?: Partial<User>) {
    Object.assign(this, dto);
  }
}
